export default __webpack_public_path__ + "static/media/check-false.6af6f63f.svg";